export const es = {
  uploading: "Subir ...",
  uploaded: "Subido",
  fetching: "Obtener imagen de $1$ ...",
  poweredBy: "Hecho posible por $1$",
  needHelp: "Necesita ayuda?",
  units: {
    px: "px",
    "%": "%",
    deg: "°"
  },
  errors: {
    response_not_ok: "Se produjo un error al recuperar este archivo",
    unable_to_search: "Se produjo un error al buscar",
    invalid_service_url: "Esta no es una URL de $1$",
    invalid_url: "Esta URL no es válida.",
    upload_aborted: "Tu carga ha sido cancelada",
    upload_error: "Se produjo un error al cargar este archivo",
    file_type_not_allowed: "Este tipo de archivo no es compatible",
    file_too_large: "El archivo debe ser inferior a $1$"
  },
  help: {
    loading: "Cargando ayuda...",
    close: "Ayuda cercana"
  },
  services: {
    default: {
      heading: "Selecciona una imagen"
    },
    local: {
      title: "Elige un archivo",
      button: "Selecciona un archivo",
      or: "de",
      drop: "Arrastra un archivo aquí para subir"
    },
    camera: {
      title: "Cámara",
      button: "Foto de la webcam",
      switch: "Cambiar de cámara",
      waiting: "Esperando el permiso de la cámara ...",
      unableToRead:
        "No podemos leer el video de su cámara. Esto puede deberse a que no ha otorgado el permiso requerido o porque su dispositivo no admite el acceso a la cámara."
    },
    microlink: {
      button: "Importar desde $1$",
      label: "$1$ $2$ URL",
      placeholder: "Ingrese una URL de $1$ $2$",
      type: "enviar"
    },
    url: {
      title: "URL directa",
      label: "URL de la imagen",
      placeholder: "Ingrese una URL de imagen"
    },
    instagram: {
      title: "Instagram"
    },
    facebook: {
      title: "Facebook"
    },
    flickr: {
      title: "Flickr",
      type: "una foto"
    },
    ninegag: {
      title: "9GAG",
      type: "una foto"
    },
    deviantart: {
      title: "DeviantArt"
    },
    artstation: {
      title: "ArtStation"
    },
    twitter: {
      title: "Gorjeo",
      type: "tweet de fotos"
    },
    pinterest: {
      title: "Pinterest",
      type: "alfiler"
    },
    flipboard: {
      title: "Flipboard",
      type: "artículo"
    },
    fotki: {
      title: "fotos",
      type: "una foto"
    },
    linkedin: {
      title: "LinkedIn"
    },
    reddit: {
      title: "Reddit"
    },
    tumblr: {
      title: "Tumblr"
    },
    weheartit: {
      title: "We Heart It"
    },
    screenshot: {
      title: "Captura de pantalla",
      button: "Tomar captura de pantalla",
      label: "URL de la página web",
      placeholder: "Ingrese una URL",
      loading: "Toma una captura de pantalla ..."
    },
    search: {
      button: "Buscar por $1$",
      label: "Busca una imagen",
      placeholder: "Buscar algo",
      imagesPoweredBy: "Imágenes posibles por $1$"
    },
    giphy: {
      title: "GIPHY"
    },
    unsplash: {
      title: "Unsplash"
    },
    pixabay: {
      title: "Pixabay"
    },
    pexels: {
      title: "Pexels"
    }
  },
  effects: {
    preview: {
      title: "Ejemplo"
    },
    filters: {
      title: "Filtros"
    },
    crop: {
      title: "Recortar",
      aspectRatios: {
        free: "Gratis",
        square: "completo"
      }
    },
    rotate: {
      title: "Girar"
    },
    flip: {
      title: "Dar la vuelta",
      buttons: {
        horizontal: "Horizontal",
        vertical: "Vertical"
      }
    },
    sharpen: {
      title: "Afilar"
    },
    blur: {
      title: "Desenfoque"
    },
    brightness: {
      title: "Brillo"
    },
    contrast: {
      title: "Contraste"
    },
    grayscale: {
      title: "Escala de grises"
    },
    "hue-rotate": {
      title: "Girar tono"
    },
    invert: {
      title: "Dar vuelta"
    },
    saturate: {
      title: "Saturar"
    },
    sepia: {
      title: "Sepia"
    }
  }
};
